import React, { useRef } from 'react';
import { debug, isProductionLikeEnvironment } from '../../common/environment-utils';
import { getIdentity } from './trackingUtlis';
const TrackingContext = React.createContext(undefined);
function TrackingProvider({ children, user, features, forceEnablementForEnvironment = false }) {
    const identity = getIdentity(user, features);
    const previousPagePath = useRef(undefined);
    const isAppCuesEnabled = () => {
        if ((forceEnablementForEnvironment || isProductionLikeEnvironment())) {
            if (!window.Appcues) {
                debug('WARNING: AppCues is not installed but you are using the provider');
                return false;
            }
            return true;
        }
        return false;
    };
    const isEnabled = isAppCuesEnabled();
    const contextState = {
        enabled: isEnabled,
        identify: () => {
            if (isEnabled) {
                debug('Tracking Identity', user.code, identity);
                window.Appcues.identify(user.code, identity);
            }
        },
        page: (path) => {
            if (isEnabled && previousPagePath.current !== path) {
                previousPagePath.current = path;
                debug('Tracking Page', path);
                window.Appcues.page();
            }
        }
    };
    debug('Tracking Enabled:', isEnabled);
    contextState.identify();
    return (React.createElement(TrackingContext.Provider, { value: contextState }, children));
}
function useTrackingState() {
    const context = React.useContext(TrackingContext);
    if (context === undefined) {
        throw new Error('useTrackingState must be used within a TrackingProvider');
    }
    return context;
}
export { TrackingProvider, useTrackingState };
//# sourceMappingURL=TrackingProvider.js.map